import React, { useEffect, useState, useContext } from "react";
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, TextField, IconButton, InputAdornment } from '@mui/material';
import Modal from 'react-bootstrap/Modal';
import { styled } from '@mui/material/styles';
import Chip from '@mui/material/Chip';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import ButtonTheme from "../../components/ThemeButton/ThemeButton";
import ApiService from '../../functions/apiService';
import moment from "moment";
import SearchIcon from "@mui/icons-material/Search";
import { varFormatTime } from "../../utils/helperFunctions";
import AuthContext from "../../context/AuthContext";

const Hitlist = (props) => {
	const { date, open, setOpen, selectedName, setSelectedName, isNight, loadData } = props
	const { user ,pages} = useContext(AuthContext);
  const [modalContent, setModalContent] = useState('default');
  const [position, setPosition] = useState('');
  const [empList, setEmpList] = useState([])
  const [search, setSearch] = useState('')
  const [empCode, setEmpCode] = useState('')
  const [positionArr, setPositionArr] = useState([])
  const [selectedNameEmp, setSelectedNameEmp] = useState('');

  const handleClose = () => {
    setOpen(false);
    setSelectedName('');
    setModalContent('default');
  }

  const handleChangeContent = (row) => {
    setModalContent('selected');
    setEmpCode(row?.Emp_Code)
    setSelectedNameEmp(row.employee.employee_assignment.EA_Rank + " " + row.employee.fullName);
  }

  const handleContentDefault = () => {
    setModalContent('default');
    setSelectedNameEmp('');
    setPosition('');
  }

  const handleChange = (event) => {
    setPosition(event.target.value);
  };

  let getHitlistEmp = () => {
    if (search == '' || search.length > 2) {
      let code = isNight ? 3 : 2
      ApiService.get(`/getHitlistEmployees?date=${moment(date).format('YYYY-MM-DD')}&shiftCode=${code}&search=${search}`)
        .then((data) => {
          setEmpList(data.data.data)
        })
        .catch(() => {
        })
    }
  }

  let getPositionDropdown = () => {
    if (empCode) {
      let code = isNight ? 3 : 2
      ApiService.get(`/getHitlistEmployeesPositions/${empCode}?date=${moment(date).format('YYYY-MM-DD')}&shiftCode=${code}`)
        .then((data) => {
          setPositionArr(data.data.data)
        })
        .catch(() => {
        })
    }
  }

  let onSubmitAssign = () => {
    const req = {
      "Shift_Number": position.Shift_Number,
      "Shift_Date": moment(date).format('YYYY-MM-DD'),
      "Emp_Code": empCode
    }
    ApiService.post('/hitlistAssignEmp', req)
      .then((res) => {
        loadData(moment(date).format('DD-MM-YYYY'))
        setOpen(false)
      }).catch((err) => {
        console.log(err)
      })
  }

  useEffect(() => {
    getHitlistEmp()
  }, [isNight, search])

  useEffect(() => {
    getPositionDropdown()
  }, [empCode])


  return (
    <>
      <Modal size="lg" show={open} onHide={handleClose}>
        <Modal.Body className='p-4'>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            {modalContent === 'default' ?
              <Typography id="modal-modal-title" sx={{ fontSize: '21px', fontWeight: '700' }}>
                {selectedName} (Available personnel)
              </Typography>
              :
              <Typography id="modal-modal-title" sx={{ fontSize: '18px', cursor: 'pointer' }} onClick={handleContentDefault}>
                Back
              </Typography>
            }
            <img src="/images/close-icon.svg" style={{ cursor: 'pointer' }} onClick={handleClose} />
          </div>
          {modalContent === 'default' ?
            <Box id="modal-modal-description" sx={{ mt: 2 }}>
              <TextField
                variant="outlined"
                placeholder="Search by Name"
                className="mt-0 w-100"
                color='secondary'
                onChange={(e) => setSearch(e.target.value)}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton>
                        <SearchIcon />
                      </IconButton>
                    </InputAdornment>
                  ),
                  sx: {
                    height: '48px',
                    fontSize: '14px'
                  },
                }}
              />
              <div style={{ maxHeight: '60vh', overflow: 'scroll', scrollbarWidth: 'none' }}>
                <TableContainer component={Paper} sx={{
                  boxShadow: 'none !important',
                  border: '1px solid #EAECF0',
                  mt: 2
                }}>
                  <Table aria-label="customized table">
                    <TableHead sx={{ backgroundColor: "#E5E9EB" }} >
                      <TableRow>
                        <TableCell>Name</TableCell>
                        <TableCell>Available Schedule</TableCell>
                        <TableCell>Seniority</TableCell>
                        <TableCell>Hours</TableCell>
                        <TableCell>Action</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {empList.length > 0 ? empList.map((row) => (
                        <TableRow key={row.employee.fullName} sx={{
                          height: '22px',
                          '& .MuiTableCell-root': {
                            border: 'none'
                          },
                          '&:nth-of-type(even)': {
                            backgroundColor: 'rgba(204, 204, 204, 0.2)',
                          },
                        }}>
                          <TableCell component="th" scope="row">
                            {`${row.employee.employee_assignment.EA_Rank} ${row.employee.fullName}`}
                          </TableCell>
                          <TableCell component="th" scope="row">
                            {moment(row.Shift_Date).format('dddd')} {row?.Value != 'FULLTIME' ? 'on ' + row.Value.replace(/(^\s*,)|(,\s*$)/g, '') : ''}
                          </TableCell>
                          <TableCell component="th" scope="row">
                            {row.employee.EHd_Seniority}
                          </TableCell>
                          <TableCell component="th" scope="row">
                            {row.Hours || '0'}
                          </TableCell>
													<TableCell component="th" scope="row" align="right">
														{(!pages.includes('V3_NEW_FILL_STRUCTURE')) || (pages.includes('V3_NEW_FILL_STRUCTURE') && row?.Shift_Call_Status == 'accepted') ?
															<Chip sx={{
																height: 'auto',
																color: 'red',
																'& .MuiChip-label': {
																	display: 'block',
																	whiteSpace: 'normal',
																},
															}}
																style={{ textAlign: 'center',  padding: '6px 0px', width: '100%', cursor: 'pointer' }}
																label='Assign Shift'
																color="red"
																onClick={() => handleChangeContent(row)}
															/>
															:
															<Chip sx={{ height: 'auto' }}
																style={{ textAlign: 'center', backgroundColor:'#d0d0d0', padding: '6px 0px', width: '100%', cursor: 'default' }}
																label='Assign Shift'
															/>
														} 
                          </TableCell>
                        </TableRow>
                      ))
                        :
                        <TableRow>
                          <TableCell colSpan={4} style={{ textAlign: 'center' }}>
                            No results found
                          </TableCell>
                        </TableRow>
                      }

                    </TableBody>
                  </Table>
                </TableContainer>
              </div>
            </Box>
            :
            <Box id="modal-modal-description" sx={{ mt: 2 }}>
              <p style={{ fontSize: '21px', fontWeight: '700' }}>{selectedNameEmp}</p>
              <Box sx={{ minWidth: 120 }}>
                {positionArr?.length === 0 ? (
                  <FormControl fullWidth>
                    <Select
                      displayEmpty
                      value={positionArr}
                      renderValue={(positionArr) => {
                        if (!positionArr || positionArr.length === 0) {
                          return <em>No open position for this user</em>;
                        }
                        return positionArr.join(", ");
                      }}
                      inputProps={{ "aria-label": "Without label" }}
                    >
                    </Select>
                  </FormControl>
                ) : (
                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">Position</InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      // value={position}
                      label="Position"
                      onChange={handleChange}
                    >
                      {positionArr.map((pos) => (
                        <MenuItem value={pos}>{pos?.employee_assignment?.position?.SO_Desc || '- '} {
													pos?.Shift_Code == 2 ? '(Day)' : pos?.Shift_Code == 3 ? '(Night)' : `(Custom ${varFormatTime(`${pos?.Start_Time}-${pos?.End_Time}`, user?.Time_Format)})`
                        }</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                )}
              </Box>
              <Box className='mt-3'>
                <ButtonTheme disabled={!position} color='primary' className='px-5' onClick={onSubmitAssign}>
                  Assign
                </ButtonTheme>
              </Box>
            </Box>
          }
        </Modal.Body>
      </Modal>
    </>
  )
}
export default Hitlist